import styles from './Faq.module.css';

const faqs = [
  {
    question: 'Por que um negócio precisa de um site profissional?',
    answer:
      'Um site profissional transmite credibilidade, fortalece a marca e permite que clientes encontrem sua empresa 24 horas por dia. Ele também facilita a geração de leads e a mensuração dos resultados com dados reais.',
  },
  {
    question: 'Qual a diferença entre um site institucional e uma landing page?',
    answer:
      'O site institucional apresenta todas as informações sobre a empresa, serviços e conteúdos. Já a landing page é focada em uma oferta específica e otimizada para conversão, ideal para campanhas de marketing.',
  },
  {
    question: 'Posso editar meu site depois que ele for entregue?',
    answer:
      'Sim. Entrego o site com um painel intuitivo para você alterar textos essenciais, imagens principais e conteúdos simples. Para mudanças estruturais ou novas funcionalidades, fico disponível para ajudar quando precisar.',
  },
  {
    question: 'Quanto tempo leva para meu site ficar pronto?',
    answer:
      'O prazo médio fica entre 10 e 15 dias úteis, dependendo do escopo e do envio dos materiais. Aplico um cronograma ágil para que você acompanhe cada etapa do processo.',
  },
  {
    question: 'Meu site será encontrado no Google? Vocês fazem SEO?',
    answer:
      'Sim. Desenvolvo o site com boas práticas de SEO técnico, velocidade, responsividade e estrutura otimizada. Também configuro ferramentas essenciais para monitorar resultados.',
  },
  {
    question: 'O que preciso fornecer para o desenvolvimento do site?',
    answer:
      'Você fornece logotipo, identidade visual (se houver), conteúdos principais e referências que gostar. Caso precise, posso auxiliar na criação de textos e imagens estratégicas.',
  },
  {
    question: 'Há custos mensais após a entrega do site?',
    answer:
      'Sim. Após o primeiro mês (incluso no projeto), cobro uma taxa mensal acessível que cobre manutenção preventiva, atualizações de segurança e suporte contínuo, além dos custos de hospedagem e domínio.',
  },
];

export default function Faq() {
  return (
    <section id="faq" className={styles.wrapper} aria-labelledby="faq-heading">
      <div className={styles.overlay} aria-hidden="true" />
      <div className={styles.container}>
        <header className={styles.header}>
          <h2 id="faq-heading">
            Tire suas dúvidas e veja como consigo ajudar <strong>sua empresa</strong>
          </h2>
        </header>

        <div className={styles.accordion}>
          {faqs.map((item) => (
            <details key={item.question} className={styles.item}>
              <summary>{item.question}</summary>
              <p>{item.answer}</p>
            </details>
          ))}
        </div>

        <a
          className={styles.ctaButton}
          href="https://wa.me/5535999564940?text=Ol%C3%A1%21%20Acabei%20de%20ver%20a%20p%C3%A1gina%20de%20d%C3%BAvidas%20do%20site%20e%20ainda%20tenho%20perguntas.%20Podemos%20conversar%3F"
          target="_blank"
          rel="noreferrer"
        >
          Eu ainda tenho dúvidas
        </a>
      </div>
    </section>
  );
}
